import { render, staticRenderFns } from "./PorCapa.vue?vue&type=template&id=17c54eef"
import script from "./PorCapa.vue?vue&type=script&lang=js"
export * from "./PorCapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports